import storeEvent from '../../utils/store-event';

export default class {
    onInput(input) {
        return {
            leftNavBtnTracking: input.leftNavBtnTracking
        };
    }
    openMobileCatLayer() {
        storeEvent.openMobileCatLayer.dispatch();
    }
}
